const RETRY_TIMEOUT = 1000

export const noop = () => null
export const ident = val => val

export const measure = name => {
  const start = performance.now()
  return {
    stop: () => {
      const end = performance.now()
      if (process.env.NODE_ENV !== 'test') {
        console.debug(`${name} took ${(end - start).toFixed(2)}ms to complete`)
      }
    },
  }
}

export async function pRetry(fn, config) {
  return fn().catch(async error => {
    if (config.retries === 0) {
      config.onFailedAttempt?.({ error, config })
      throw error
    }
    await new Promise(resolve => {
      const timeout = setTimeout(() => {
        clearTimeout(timeout)
        resolve()
      }, RETRY_TIMEOUT)
    })
    return pRetry(fn, { ...config, retries: config.retries - 1 })
  })
}

export const coalesce = (...args) =>
  args.find(arg => !(arg === null || typeof arg === 'undefined'))
export const join = (...args) => args.filter(Boolean).join('')
